import React from 'react';
import PropTypes from 'prop-types';

import { Tiny } from 'components';

const Header = (props) => {
  const {
    labelElement,
    id,
    label,
    required,
    errors,
    className = '',
    labelClassName = '',
    showLabel = true,
    parentComponent,
  } = props;
  return (
    <div className={`flex ${label && 'mb-1'}  items-end ${className}`}>
      {label && (
        <Tiny
          className={`${!showLabel && 'hidden'} ${labelClassName}`}
          weight="semibold"
        >
          {/* label area */}
          {labelElement || (
            <label htmlFor={id}>
              {label}
              {required ? <div> *</div> : null}
            </label>
          )}
          {/* error area */}
        </Tiny>
      )}
      {errors && (
        <Tiny
          variant="error"
          className={`${!errors && 'opacity-0'} ${
            parentComponent === 'DeliveryFollow' && 'bg-white p-2 mb-2'
          } ml-2`}
        >
          {errors ? errors : '-'}
        </Tiny>
      )}
    </div>
  );
};

export default Header;

Header.propTypes = {
  labelElement: PropTypes.any,
  id: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  showLabel: PropTypes.bool,
  errors: PropTypes.string,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  parentComponent: PropTypes.string,
};
